import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const sidePanelOpenSequenceState = createAtomState<number>({
  key: 'sidePanelOpenSequenceState',
  defaultValue: 0,
});
